// Runtime configuration fetched from server
// This allows the app to adapt to different deployment environments

export type StorageMode = 'local' | 'gdrive'

export interface RuntimeConfig {
  storageMode: StorageMode
}

let cachedConfig: RuntimeConfig | null = null

/**
 * Fetch runtime configuration from the server
 * This is called once at app startup
 */
export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  if (cachedConfig) {
    return cachedConfig
  }

  try {
    const response = await fetch('/api/config')
    if (!response.ok) {
      throw new Error(`Failed to load config: ${response.statusText}`)
    }
    const config: RuntimeConfig = await response.json()
    cachedConfig = config
    console.log('Runtime configuration loaded:', config)
    return config
  }
  catch (error) {
    console.error('Failed to load runtime config, using defaults:', error)
    // Fallback to defaults if config endpoint fails
    const defaultConfig: RuntimeConfig = {
      storageMode: 'local',
    }
    cachedConfig = defaultConfig
    return defaultConfig
  }
}

/**
 * Get the cached runtime configuration
 * Must call loadRuntimeConfig() first
 */
export function getRuntimeConfig(): RuntimeConfig {
  if (!cachedConfig) {
    throw new Error('Runtime config not loaded. Call loadRuntimeConfig() first.')
  }
  return cachedConfig
}
